<template>
  <v-container grid-list-md text-xs-center>
    <CourseDetial />
    <v-layout row wrap align-center>
      <v-flex md3>
        <v-select
          :label="labels.department"
          v-model="selectDepartment"
          :items="departments"
          :item-text="departmentText[select_language.lang]"
          item-value="DeptNo"
        ></v-select>
      </v-flex>
      <v-flex md2>
        <v-text-field
          :label="labels.course_code"
          v-model="courseNo"
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-text-field
          :label="labels.chinese_course_title"
          v-model="courseName"
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-text-field
          :label="labels.english_course_title"
          v-model="engName"
        ></v-text-field>
      </v-flex>
      <v-flex md1>
        <v-btn round block :disabled="loadingState" @click="query()">
          <v-icon>search</v-icon>
          {{ labels.search }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="info"
          :loading="loadingState"
          :rows-per-page-items="rowsPerPageItems"
          :rows-per-page-text="labels.rows_per_page"
          :no-data-text="labels.no_data"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.CourseNo }}</td>
            <td>{{ props.item.DepAliase }}</td>
            <td>{{ props.item.CreditPoints }}</td>
            <td>{{ props.item.CourseTimes }}</td>
            <td>{{ props.item.PracticalTimes }}</td>
            <td>{{ props.item.CourseName }}</td>
            <td>{{ props.item.CourseEngName }}</td>
            <td>{{ props.item.Outline }}</td>
            <td>{{ props.item.EngOutline }}</td>
            <td>{{ props.item.DimContents }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CourseDetial from "../components/CourseDetial";
import languages from "../languages/CourseTitleAndOutline.json";

export default {
  components: {
    CourseDetial,
  },
  data: () => ({
    labels: {
      department: "",
      course_code: "",
      chinese_course_title: "",
      english_course_title: "",
      search: "",
      rows_per_page: "",
      no_data: "",
    },
    departments: [],
    departmentText: { zh: "Department", en: "EngDepartment" },
    selectDepartment: "",
    courseNo: "",
    courseName: "",
    engName: "",
    info: [],
    loadingState: false,
    headers: [],
    rowsPerPageItems: [50, 100, { text: "All", value: -1 }],
  }),
  computed: {
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
    this.getDepartment();
  },
  methods: {
    getDepartment() {
      fetch("api/departments")
        .then((response) => response.json())
        .then((data) => {
          let result = [
            {
              DeptNo: "",
              Department: "所有系所",
              EngDepartment: "All",
            },
            {
              DeptNo: "NU",
              Department: "校外NU",
              EngDepartment: "NU",
            },
            {
              DeptNo: "TU",
              Department: "校外TU",
              EngDepartment: "TU",
            },
          ].concat(data);
          this.selectDepartment = "";
          this.departments = result;
        });
    },
    query() {
      this.loadingState = true;
      fetch(
        "api/ArchivedTitleAndOutline?DeptNo=" +
          String(this.selectDepartment) +
          "&CourseName=" +
          String(this.courseName) +
          "&EngName=" +
          String(this.engName) +
          "&CourseNo=" +
          String(this.courseNo)
      ).then((response) =>
        response.json().then((data) => {
          this.info = data;
          this.loadingState = false;
        })
      );
    },
    showDeital: function (course_no) {
      this.$store.dispatch("queryDetial", {courseNo:course_no, Semester:""});
    },
    setLanguage: function (select_language) {
      this.labels.department = languages.department[select_language.lang];
      this.labels.course_code = languages.course_code[select_language.lang];
      this.labels.chinese_course_title =
        languages.chinese_course_title[select_language.lang];
      this.labels.english_course_title =
        languages.english_course_title[select_language.lang];
      this.labels.search = languages.search[select_language.lang];

      this.headers = [
        {
          text: languages.course_code[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.open_department[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.credits[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.course_time[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.lab_time[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.course_title[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.english_course_title[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.chinese_outline[select_language.lang],
          width: "20%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.english_outline[select_language.lang],
          width: "20%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.ge_type[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
      ];

      this.rowsPerPageItems = [
        50,
        100,
        { text: languages.all[select_language.lang], value: -1 },
      ];
    },
  },
};
</script>
